export const API = "https://billsoft.askonly.in/api";
